// @ts-ignore
// This is to async load the dependencies from webpack
import('./boostrap.tsx')
